import React, { Fragment } from "react";
import { View, Text, StyleSheet, Linking, Pressable } from "react-native";

import { IChatConversationModel } from "../../services/models/chat";
import {
  ExelIcon,
  FileIcon,
  PdfIcon,
  PowerPointIcon,
  WordIcon,
} from "../Icons";
import { colors } from "../Shared";
import AutoSizeImage from "./AutoSizeImage";
import VoiceItem from './VoiceItem';

interface Props {
  conversation: IChatConversationModel;
  isMe: boolean;
}

export default function MessageItem({ conversation, isMe }: Props) {
  const { message, type, url, fileName } = conversation;

  if (conversation.type == 'voice') {
    return <VoiceItem { ...conversation } />
  }

  const RenderImage = () => {
    if (type !== "image" || typeof url !== "string") {
      return <></>;
    }

    return <AutoSizeImage uri={url} />;
  };

  const RenderIconFile = () => {
    const ext = fileName?.split(".").reverse()[0];
    if (ext === "pdf") {
      return <PdfIcon size={19} color="#ff0000" />;
    }

    if (ext === "docx" || ext === "dot" || ext === "dotx") {
      return <WordIcon size={19} color="#2b579a" />;
    }

    if (ext === "pot" || ext === "potm" || ext === "potx") {
      return <PowerPointIcon size={19} color="#d24726" />;
    }

    if (
      ext === "xla" ||
      ext === "xlam" ||
      ext === "xll" ||
      ext === "xlm" ||
      ext === "xls" ||
      ext === "xlsm" ||
      ext === "xlsx" ||
      ext === "xlt" ||
      ext === "xltm" ||
      ext === "xltx"
    ) {
      return <ExelIcon size={19} color="#217346" />;
    }

    return <FileIcon size={19} />;
  };

  const RenderFile = () => {
    if (type !== "file") {
      return <Fragment />;
    }

    return (
      <Pressable
        onPress={() => Linking.openURL(url)}
        style={[styles.renderFileContainer, { backgroundColor: isMe ? "#ffffff40" : "#00000010"}]}
      >
        {RenderIconFile()}
        <Text style={{ color: isMe ? colors.text.white : "", marginLeft: 10}}>{fileName}</Text>
      </Pressable>
    );
  };

  const renderText = () => {
    if (!message) {
      return <Fragment />;
    }

    return (
      <Text
        style={[styles.messageText, { color: isMe ? colors.text.white : "" }]}
      >
        {message}
      </Text>
    );
  };

  return (
    <View
      style={[
        styles.container,
        { flexDirection: isMe ? "row-reverse" : "row" },
      ]}
    >
      <View
        style={[styles.message, isMe ? styles.myMessage : styles.themMessage]}
      >
        {RenderImage()}
        {RenderFile()}
        {renderText()}
      </View>

      <View style={{ flex: 1 }} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    minHeight: 10,
    marginVertical: 5,
    transform: [{ scaleY: -1 }]
  },
  message: {
    minHeight: 10,
    maxWidth: "85%",
    padding: 10,
  },
  myMessage: {
    borderRadius: 10,
    backgroundColor: colors.bg.green,
  },
  themMessage: {
    backgroundColor: colors.bg.medium,
    borderRadius: 10,
  },
  name: {
    paddingBottom: 5,
    textTransform: "capitalize",
    fontWeight: "500",
    fontSize: 14,
  },
  messageText: {
    fontSize: 15,
    textAlign: "left",
  },
  renderFileContainer: {
    backgroundColor: "#ffffff60",
    marginBottom: 5,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: 10,
    borderRadius: 10,
  },
});
